export const readFileContentAsBuffer = (file: File) => {
    return new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener(
            "load",
            () => {
                resolve(reader.result as ArrayBuffer);
            },
            false,
        );
        reader.addEventListener(
            "error",
            (error) => reject(error),
            false,
        );
        reader.readAsArrayBuffer(file);
    });
};
